'use strict';

export default class AjaxStack
{
    constructor(actions, dispatcher, options)
    {
        options = options || {};

        this._actions = JSON.parse(JSON.stringify(actions));
        this._dispatcher = dispatcher;
        this._status = {};
        
        this._options = Object.assign({}, { concurrency: 1 }, options);
    }

    run()
    {
        // Sort actions.
        for(const i in this._actions)
        {
            const action = this._actions[i].action;
            this._status[action] = 0;
        }

        return new Promise((resolve, reject) => 
        {
            for(const i in this._actions)
            {
                this._pop(resolve, reject);
            }
        });
    }

    _currentlyRunning()
    {
        let nbRunning = 0;

        for(const i in this._status)
        {
            if(this._status[i] === 1)
            {
                nbRunning += 1;
            }
        }

        return nbRunning;
    }

    _pop(resolve, reject)
    {
        if(this._canPop())
        {
            let found = false;
            let cAction = null;

            for(const i in this._actions)
            {
                if(this._canRun(this._actions[i]))
                {
                    found = true;
                    cAction = this._actions.splice(i, 1)[0];

                    break;
                }
            }

            if(found)
            {
                this._status[cAction.action] = 1;

                this._dispatcher(cAction.action)
                    .then(() =>
                    {
                        this._status[cAction.action] = 2;

                        if(!this._allRun())
                        {
                            this._pop(resolve, reject);
                        }
                        else
                        {
                            resolve(true);
                        }
                    })
                    .catch(error =>
                    {
                        this._status[cAction.action] = 2;

                        reject(error);
                    });
            }
        }
    }

    _canPop()
    {
        return this._currentlyRunning() <= this._options.concurrency;
    }

    _canRun(action)
    {
        // Check that action is not already running.
        if(this._status[action.action] !== 0)
        {
            return false;
        }

        // If action has no dependencies.
        if(!action.after)
        {
            return true;
        }
        else
        {
            let canRun = true;
            
            const dependentActions = action.after;
            for(let i in dependentActions)
            {
                let dependentAction = dependentActions[i];

                if(this._status[dependentAction] < 2)
                {
                    canRun = false;
                }
            }

            return canRun;
        }
    }

    _allRun()
    {
        for(const i in this._status)
        {
            if(this._status[i] < 2)
            {
                return false;
            }
        }

        return true;
    }
}